<script>
export default {
  data() {
    return {
      xPoints: [],
      mouseXPosition: 0,
    };
  },
  computed: {
    parent() {
      return document.getElementById(this.container);
    },
    width() {
      return parseInt(
        getComputedStyle(this.parent).getPropertyValue("width").slice(0, -2)
      );
    },
    height() {
      return parseInt(
        getComputedStyle(this.parent).getPropertyValue("height").slice(0, -2)
      );
    },
    largestNumber() {
      let series = [];
      this.chartData.forEach((x) => {
        series.push(...x.data);
      });
      return Math.max(...series);
    },
  },
  methods: {
    addXPoint(x) {
      if (!this.xPoints.includes(x)) {
        this.xPoints.push(x);
      }
    },
    createBaseSvg() {
      this.baseSvg = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "svg"
      );
      this.baseSvg.setAttribute("viewBox", `0 0 ${this.width} ${this.height}`);
      this.baseSvg.setAttribute("overflow", `visible`);
      this.baseSvg.setAttribute("preserveAspectRatio", "none");
      this.baseSvg.setAttribute("min-height", this.height + 5 + "px");
      this.baseSvg.style.pointerEvents = "none";
      this.parent.appendChild(this.baseSvg);
    },
    createBezierCommand(point, i, a) {
      const [cpsX, cpsY] = this.createControlPoint(a[i - 1], a[i - 2], point); // end control point
      const [cpeX, cpeY] = this.createControlPoint(
        point,
        a[i - 1],
        a[i + 1],
        true
      );
      return `C ${cpsX},${cpsY} ${cpeX},${cpeY} ${point[0]},${point[1]}`;
    },
    createControlPoint(current, previous, next, reverse) {
      // When 'current' is the first or last point of the array
      // 'previous' or 'next' don't exist.
      // Replace with 'current'
      const p = previous || current;
      const n = next || current; // The smoothing ratio
      const smoothing = 0.2; // Properties of the opposed-line
      const o = this.createLine(p, n); // If is end-control-point, add PI to the angle to go backward
      const angle = o.angle + (reverse ? Math.PI : 0);
      const length = o.length * smoothing; // The control point position is relative to the current point
      const x = current[0] + Math.cos(angle) * length;
      const y = current[1] + Math.sin(angle) * length;
      return [x, y];
    },
    createLine(pointA, pointB) {
      const lengthX = pointB[0] - pointA[0];
      const lengthY = pointB[1] - pointA[1];
      return {
        length: Math.sqrt(Math.pow(lengthX, 2) + Math.pow(lengthY, 2)),
        angle: Math.atan2(lengthY, lengthX),
      };
    },
    createSvgPath(points, command, color) {
      const d = points.reduce(
        (acc, point, i, a) =>
          i === 0 // if first point
            ? `M ${point[0]},${point[1]}` // else
            : `${acc} ${command(point, i, a)}`,
        ""
      );
      return `<path d="${d}" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" width="100%" data-points="${points.toString()}"/>`;
    },
    drawPath(series, order) {
      let { data, color } = series;
      let points = [];
      data.forEach((num, index) => {
        let x = (index / (data.length - 1)) * this.width;
        this.addXPoint(x);
        let y;
        if (num !== 0) {
          y = this.height - (num / this.largestNumber) * this.height;
        } else {
          y = this.height - num;
        }
        if (y >= 0 && y <= 20) {
          y = 20;
        }
        if (y <= this.height && y > this.height - 20) {
          y = this.height - 20;
        }
        y += order * 2;
        points.push([x, y]);
      });
      return this.createSvgPath(points, this.createBezierCommand, color);
    },
    processData() {
      for (let index = 0; index < this.chartData.length; index++) {
        const series = this.chartData[index];
        this.baseSvg.innerHTML += this.drawPath(series, index);
      }
    },
  },
  mounted() {
    this.createBaseSvg();
    this.processData();
    let tallestPathHeight = 0;
    let widestPathWidth = 0;
    this.baseSvg.childNodes.forEach((path) => {
      let boundingBox = path.getBBox();
      if (boundingBox.width > widestPathWidth) {
        widestPathWidth = boundingBox.width;
      }
      if (boundingBox.height > tallestPathHeight) {
        tallestPathHeight = boundingBox.height;
      }
    });
  },
  props: ["container", "mousePosition", "chartData"],
};
</script>
<style scoped></style>
